module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-DeleteNotification-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('notificationsDeleteDialogTitle')))]), _vm._v(" "), _c('span', {
    attrs: {
      "data-qa": "Dialog-DeleteNotification-ConfirmText"
    }
  }, [_vm._v(_vm._s(_vm.$t('notificationsDeleteDialogConfirmText')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('el-button', {
    staticClass: "btn-close",
    attrs: {
      "data-qa": "Dialog-DeleteNotification-Button-Close",
      "type": "text"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('notificationsDeleteDialogButtonCancelText')) + "\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading,
      "loading": _vm.loading,
      "data-qa": "Dialog-DeleteNotification-Button-Delete",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.deleteNotification(_vm.id)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('notificationsDeleteDialogButtonDeleteText')) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cad4f1c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotificationsDelete/NotificationsDelete.vue
// module id = 952
// module chunks = 3